<div class="alert alert-warning">
    <span class="font-weight-bold">{{ 'common.controlled-by-magaya.line-1' | translate }}</span>
    <span>&nbsp;{{ 'common.controlled-by-magaya.line-2' | translate }}</span>
</div>
